"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotTestResults = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const console_1 = require("@rws-framework/console");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/rws-tools/component");
component_1.RWSToolsComponent;
//@ts-ignore                
let rwsTemplate = T.html `<div class="test-results-container">
  ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
    <div class="text-center py-5">
      <app-loader></app-loader>
    </div>
  `, (0, fast_element_1.html) `
    ${(0, fast_element_1.when)(x => x.testResults && x.testResults.length > 0, (0, fast_element_1.html) `
      <div class="row">
        <div class="col-12">
          <h5 class="mb-3">
            <i class="simple-icon-chart mr-2"></i>
            ${'botTest.testResults.title'.t()}
          </h5>
          
          
          <div class="accordion" id="testResultsAccordion">
            ${(0, fast_element_1.repeat)(x => x.groupedResults, (0, fast_element_1.html) `
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button 
                    class="accordion-button ${(x, c) => c.index === 0 ? '' : 'collapsed'}" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target="#collapse-${x => x.sanitizedId}" 
                    aria-expanded="${(x, c) => c.index === 0 ? 'true' : 'false'}" 
                    aria-controls="collapse-${x => x.sanitizedId}"
                  >
                    <div class="w-100">
                      <div class="d-flex justify-content-between align-items-center">
                        <span class="fw-bold">${x => x.testerName} → ${x => { var _a, _b; return ((_b = (_a = x.target) === null || _a === void 0 ? void 0 : _a.avatar) === null || _b === void 0 ? void 0 : _b.name) || 'Unknown Target'; }}</span>
                        <span class="badge bg-primary">${x => x.results.length} ${'botTest.testResults.results'.t()}</span>
                      </div>
                    </div>
                  </button>
                </h2>
                <div 
                  id="collapse-${x => x.sanitizedId}" 
                  class="accordion-collapse collapse ${(x, c) => c.index === 0 ? 'show' : ''}" 
                  data-bs-parent="#testResultsAccordion"
                >
                  <div class="accordion-body">
                    ${(0, fast_element_1.repeat)(x => x.results, (0, fast_element_1.html) `
                      <div class="card mb-3">
                        <div class="card-header">
                          <div class="d-flex align-items-center">
                            <div class="flex-shrink-0">
                              <button 
                                class="btn btn-sm btn-link p-0 me-2 text-decoration-none collapse-toggle"
                                @click="${(x, c) => c.parentContext.parent.toggleResultCollapse(x.id)}"
                                type="button"
                              >
                                <i class="simple-icon-arrow-${(x, c) => c.parentContext.parent.isResultCollapsed(x.id) ? 'right' : 'down'}"></i>
                              </button>
                            </div>
                            <div class="flex-fill text-center">
                              <h6 class="mb-0">${'botTest.testResults.result'.t()} #${x => x.id}</h6>
                            </div>
                            <div class="flex-shrink-0 d-flex align-items-center">
                              <strong class="me-3">${(x, c) => c.parentContext.parent.formatDate(x.endTime)}</strong>
                              <span class="badge ${(x, c) => c.parentContext.parent.getStatusBadgeClass(x)}">${(x, c) => c.parentContext.parent.getStatusLabel(x)}</span>
                            </div>
                            <div class="flex-shrink-0 ml-1 d-flex align-items-center">
                              <a href="${(x, c) => c.parentContext.parent.pdfRoute(x.id)}" target="_blank" class="btn btn-danger btn-sm text-white btn-outline-primary">
                                <i class="simple-icon-doc"></i>PDF
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="card-body ${(x, c) => c.parentContext.parent.isResultCollapsed(x.id) ? 'collapse' : ''}">
                          <div class="row">
                            <div class="col-md-6">
                              <h6>${'botTest.testResults.metrics'.t()}</h6>
                              <ul class="list-unstyled small">
                                <li><strong>${'botTest.testResults.totalMessages'.t()}:</strong> ${x => x.totalMessages || 0}</li>
                                <li><strong>${'botTest.testResults.totalTokens'.t()}:</strong> ${x => x.totalTokens || 0}</li>
                                <li><strong>${'botTest.testResults.totalCost'.t()}:</strong> ${x => x.totalCost || 0}</li>
                                <li><strong>${'botTest.testResults.executionTime'.t()}:</strong> ${(x, c) => c.parentContext.parent.formatMs(x.executionTime)}s</li>
                                <li><strong>${'botTest.testResults.averageResponseTime'.t()}:</strong> ${(x, c) => c.parentContext.parent.formatMs(x.averageResponseTime)}s</li>
                              </ul>
                            </div>
                            <div class="col-md-6">
                              ${(0, fast_element_1.when)((x, c) => c.parentContext.parent.getErrorMessage(x), (0, fast_element_1.html) `
                                <h6 class="text-danger">${'botTest.testResults.error'.t()}</h6>
                                <div class="alert alert-danger">
                                  <small>${(x, c) => c.parentContext.parent.getErrorMessage(x)}</small>
                                </div>
                              `)}
                              ${(0, fast_element_1.when)(x => x.questionGenerationSuccess !== undefined, (0, fast_element_1.html) `
                                <h6>${'botTest.testResults.questionGeneration'.t()}</h6>
                                <ul class="list-unstyled small">
                                  <li><strong>${'botTest.testResults.success'.t()}:</strong> ${x => x.questionGenerationSuccess ? 'Yes' : 'No'}</li>
                                  <li><strong>${'botTest.testResults.tokens'.t()}:</strong> ${x => x.questionGenerationTokens || 0}</li>
                                  <li><strong>${'botTest.testResults.cost'.t()}:</strong> ${x => x.questionGenerationCost || 0}</li>
                                </ul>
                              `)}
                            </div>
                          </div>

                          
                          ${(0, fast_element_1.when)(x => x.questions && x.questions.length > 0, (0, fast_element_1.html) `
                            <hr class="my-3">
                            <div class="row">
                              <div class="col-12">
                                <h6>${'botTest.testResults.questionsAndAnswers'.t()}</h6>
                                <div class="questions-answers-container">
                                  ${(0, fast_element_1.repeat)((x, c) => { var _a; return ((_a = x.questions) === null || _a === void 0 ? void 0 : _a.map((q, index) => { var _a, _b, _c; return ({ question: q, answer: ((_a = x.answers) === null || _a === void 0 ? void 0 : _a[index]) || 'No answer', tools: ((_b = x.toolsUsed) === null || _b === void 0 ? void 0 : _b[index]) || [], answerStartTime: ((_c = x.answerStartTimes) === null || _c === void 0 ? void 0 : _c[index]) || null, index }); })) || []; }, (0, fast_element_1.html) `
                                    <div class="qa-pair mb-3">
                                      <div class="card border-light">
                                        <div class="card-header bg-light py-2">
                                          <h6 class="mb-0 text-primary">
                                            <i class="simple-icon-question mr-2"></i>
                                            ${'botTest.testResults.question'.t()} ${x => x.index + 1}
                                          </h6>
                                        </div>
                                        <div class="card-body py-2">
                                          <div class="mb-2">
                                            <strong class="text-muted small">${'botTest.testResults.questionLabel'.t()}:</strong>
                                            <div class="mt-1">${x => x.question}</div>
                                          </div>
                                          <div>
                                            <strong class="text-muted small">${'botTest.testResults.answerLabel'.t()}:</strong>
                                            <div class="mt-1" :innerHTML="${x => x.answer || 'No answer'}"></div>
                                          </div>
                                          ${(0, fast_element_1.when)(x => x.answerStartTime, (0, fast_element_1.html) `
                                            <div class="mt-1">
                                              <small class="text-muted">
                                                <i class="simple-icon-clock mr-1"></i>
                                                ${'botTest.testResults.answerStartTime'.t()}: ${(x, c) => c.parentContext.parentContext.parent.formatAnswerStartTime(x.answerStartTime)}
                                              </small>
                                            </div>
                                          `)}
                                          ${(0, fast_element_1.when)(x => x.tools && x.tools.length > 0, (0, fast_element_1.html) `
                                            <div class="mt-2">
                                              <rws-tools data="${x => JSON.stringify(x.tools)}"></rws-tools>
                                            </div>
                                          `)}
                                        </div>
                                      </div>
                                    </div>
                                  `)}
                                </div>
                              </div>
                            </div>
                          `)}
                        </div>
                      </div>
                    `)}
                  </div>
                </div>
              </div>
            `)}
          </div>
        </div>
      </div>
    `, (0, fast_element_1.html) `
      <div class="text-center py-5">
        <i class="simple-icon-chart text-muted" style="font-size: 3rem;"></i>
        <h5 class="text-muted mt-3">${'botTest.testResults.no_results'.t()}</h5>
        <p class="text-muted">${'botTest.testResults.no_results_description'.t()}</p>
      </div>
    `)}
  `)}
</div>`;
require("./styles/layout.scss");
const styles = T.css `.test-results-container .accordion-item {
  border: 1px solid #e9ecef;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
}
.test-results-container .accordion-item button {
  background-color: var(--chat_header_color);
  color: var(--primary-color);
  box-shadow: none;
  display: block;
  width: 100%;
  border: none;
  cursor: pointer;
}
.test-results-container .accordion-item button .badge {
  margin-left: 0.5rem;
}
.test-results-container .accordion-button {
  padding: 1rem;
}
.test-results-container .accordion-button:focus {
  box-shadow: none;
}
.test-results-container .accordion-body {
  padding: 1.5rem;
}
.test-results-container .card {
  border: 1px solid #e9ecef;
}
.test-results-container .card .card-header {
  background-color: #f8f9fa;
  padding: 0.75rem 1rem;
}
.test-results-container .card .card-header .collapse-toggle {
  color: var(--bs-primary);
  background: none;
  border: none;
  padding: 0.25rem;
  transition: transform 0.2s ease;
}
.test-results-container .card .card-header .collapse-toggle:hover {
  color: var(--bs-primary);
  transform: scale(1.1);
}
.test-results-container .card .card-header .collapse-toggle:focus {
  box-shadow: none;
  outline: none;
}
.test-results-container .card .card-header .collapse-toggle i {
  font-size: 0.875rem;
  transition: transform 0.2s ease;
}
.test-results-container .card .card-header .badge {
  margin-left: 0.5rem;
}
.test-results-container .card .card-body {
  padding: 1rem;
  transition: all 0.3s ease;
}
.test-results-container .card .card-body.collapse {
  display: none;
}
.test-results-container .badge {
  font-size: 0.75rem;
}
.test-results-container .alert {
  padding: 0.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
}
.test-results-container .bg-light {
  background-color: #f8f9fa !important;
}`;
const shadowOptions = { "mode": "open" };
let BotTestResults = class BotTestResults extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.botTest = null;
        this.testResults = [];
        this.loading = false;
        this.collapsedResults = new Set();
    }
    async connectedCallback() {
        super.connectedCallback();
        if (this.botTest) {
            await this.loadTestResults();
        }
    }
    botTestChanged() {
        if (this.botTest) {
            this.loadTestResults();
        }
    }
    async loadTestResults() {
        var _a;
        this.loading = true;
        try {
            // Collect all test results from all targets across all testers
            const allResults = [];
            if ((_a = this.botTest) === null || _a === void 0 ? void 0 : _a.testers) {
                for (const tester of this.botTest.testers) {
                    if (tester.targets) {
                        for (const target of tester.targets) {
                            if (target.testResults) {
                                allResults.push(...target.testResults);
                            }
                        }
                    }
                }
            }
            // Sort results by ID in descending order
            allResults.sort((a, b) => {
                const aId = Number(a.id) || 0;
                const bId = Number(b.id) || 0;
                return bId - aId;
            });
            this.testResults = allResults;
            // Initialize collapsed results - collapse all except first result in each tester group
            this.initializeDefaultCollapsedState();
            // Initialize accordions after DOM update
            setTimeout(() => this.initializeAccordions(), 100);
        }
        catch (error) {
            console.error('Failed to load test results:', error);
            this.testResults = [];
        }
        finally {
            this.loading = false;
        }
    }
    initializeDefaultCollapsedState() {
        const collapsedIds = new Set();
        // Get grouped results to determine first result in each group
        const groups = this.groupedResults;
        groups.forEach(group => {
            // Skip the first result in each group, collapse the rest
            group.results.forEach((result, index) => {
                if (index > 0) { // Keep first result (index 0) expanded
                    collapsedIds.add(String(result.id));
                }
            });
        });
        this.collapsedResults = collapsedIds;
    }
    testResultsChanged() {
        // Reinitialize accordions when test results change
        setTimeout(() => this.initializeAccordions(), 100);
    }
    initializeAccordions() {
        var _a;
        // Find all accordion elements and make sure they're properly initialized
        const accordions = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.accordion');
        if (accordions) {
            accordions.forEach((accordion) => {
                // Make sure Bootstrap accordion is working
                const buttons = accordion.querySelectorAll('[data-bs-toggle="collapse"]');
                buttons.forEach((button) => {
                    var _a;
                    // Remove existing listeners
                    const newButton = button.cloneNode(true);
                    (_a = button.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(newButton, button);
                    // Add new listener
                    newButton.addEventListener('click', this.handleAccordionClick.bind(this));
                });
            });
        }
    }
    handleAccordionClick(event) {
        var _a, _b, _c;
        event.preventDefault();
        const button = event.currentTarget;
        const target = button.getAttribute('data-bs-target');
        if (target) {
            const collapseElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(target);
            if (collapseElement) {
                const isExpanded = button.getAttribute('aria-expanded') === 'true';
                // Close all other accordion items first
                const allCollapses = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('.accordion-collapse');
                const allButtons = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelectorAll('.accordion-button');
                allCollapses === null || allCollapses === void 0 ? void 0 : allCollapses.forEach(collapse => {
                    if (collapse !== collapseElement) {
                        collapse.classList.remove('show');
                    }
                });
                allButtons === null || allButtons === void 0 ? void 0 : allButtons.forEach(btn => {
                    if (btn !== button) {
                        btn.classList.add('collapsed');
                        btn.setAttribute('aria-expanded', 'false');
                    }
                });
                // Toggle the clicked item
                if (isExpanded) {
                    collapseElement.classList.remove('show');
                    button.classList.add('collapsed');
                    button.setAttribute('aria-expanded', 'false');
                }
                else {
                    collapseElement.classList.add('show');
                    button.classList.remove('collapsed');
                    button.setAttribute('aria-expanded', 'true');
                }
            }
        }
    }
    sanitizeId(id) {
        return `tester-${id}`.replace(/[^a-zA-Z0-9-_]/g, '');
    }
    processAnswerHtml(answer) {
        // Simple HTML processing - in a real app you'd want proper sanitization
        if (!answer)
            return 'No answer';
        // For now, just return the HTML as-is since it's coming from our own system
        // In production, consider using a proper HTML sanitization library like DOMPurify
        return answer;
    }
    get groupedResults() {
        if (!this.testResults.length || !this.botTest)
            return [];
        // Create a mapping from target ID to tester info
        const targetToTesterMap = new Map();
        if (this.botTest.testers) {
            this.botTest.testers.forEach(tester => {
                if (tester.targets) {
                    tester.targets.forEach(target => {
                        targetToTesterMap.set(target.id, {
                            testerId: tester.id,
                            testerName: tester.name || `Tester ${tester.id}`,
                            target: target
                        });
                    });
                }
            });
        }
        // Group results by tester-target combination (not just by tester)
        const groups = new Map();
        this.testResults.forEach(result => {
            const targetId = result === null || result === void 0 ? void 0 : result.bot_test_target_id;
            const testerInfo = targetToTesterMap.get(targetId) || {
                testerId: 'unknown',
                testerName: 'Unknown Tester',
                target: { id: targetId, avatar: { name: 'Unknown Target' } }
            };
            // Use both testerId and targetId to create unique groups
            const groupKey = `${testerInfo.testerId}-${targetId}`;
            if (!groups.has(groupKey)) {
                groups.set(groupKey, {
                    testerId: testerInfo.testerId,
                    targetId: targetId,
                    testerName: testerInfo.testerName,
                    target: testerInfo.target,
                    results: [],
                    sanitizedId: this.sanitizeId(groupKey)
                });
            }
            groups.get(groupKey).results.push(result);
        });
        return Array.from(groups.values());
    }
    formatDate(date) {
        if (!date)
            return 'N/A';
        try {
            return console_1.DateUtils.create(date).format('dd.MM.yyyy HH:mm:ss');
        }
        catch (error) {
            console.error('Error formatting date:', date);
            return String(date);
        }
    }
    formatAnswerStartTime(ts) {
        if (!ts && ts !== 0)
            return 'N/A';
        // Legacy data stored absolute timestamps (ms since epoch); new data stores relative seconds
        if (ts > 1000)
            return 'N/A';
        return ts.toFixed(2) + 's';
    }
    formatMs(ms) {
        if (!ms)
            return '0';
        return (ms / 1000).toFixed(2);
    }
    toggleResultCollapse(resultId) {
        const id = String(resultId);
        if (this.collapsedResults.has(id)) {
            this.collapsedResults.delete(id);
        }
        else {
            this.collapsedResults.add(id);
        }
        // Trigger observable update
        this.collapsedResults = new Set(this.collapsedResults);
    }
    isResultCollapsed(resultId) {
        return this.collapsedResults.has(String(resultId));
    }
    pdfRoute(resultId) {
        if (!resultId)
            return '';
        return this.apiService.getBackendUrl('bot-test.pdf', { id: String(resultId) });
    }
    /**
     * Normalizes the status field to ensure it contains only valid status values
     */
    getNormalizedStatus(result) {
        const validStatuses = [backendImport_1.TestResultStatus.PENDING, backendImport_1.TestResultStatus.RUNNING, backendImport_1.TestResultStatus.COMPLETED, backendImport_1.TestResultStatus.FAILED];
        if (!result.status || !validStatuses.includes(result.status)) {
            return backendImport_1.TestResultStatus.FAILED;
        }
        return result.status;
    }
    /**
     * Gets the CSS class for the status badge
     */
    getStatusBadgeClass(result) {
        const status = this.getNormalizedStatus(result);
        switch (status) {
            case backendImport_1.TestResultStatus.COMPLETED: return 'bg-success';
            case backendImport_1.TestResultStatus.FAILED: return 'bg-danger';
            case backendImport_1.TestResultStatus.RUNNING:
            case backendImport_1.TestResultStatus.PENDING: return 'bg-info';
            default: return 'bg-secondary';
        }
    }
    /**
     * Gets the display label for the status
     */
    getStatusLabel(result) {
        const status = this.getNormalizedStatus(result);
        switch (status) {
            case backendImport_1.TestResultStatus.PENDING: return 'botTest.testResults.status.pending'.t();
            case backendImport_1.TestResultStatus.RUNNING: return 'botTest.testResults.status.running'.t();
            case backendImport_1.TestResultStatus.COMPLETED: return 'botTest.testResults.status.completed'.t();
            case backendImport_1.TestResultStatus.FAILED: return 'botTest.testResults.status.failed'.t();
            default: return status;
        }
    }
    /**
     * Gets the error message, handling cases where status contains error text
     */
    getErrorMessage(result) {
        const validStatuses = [backendImport_1.TestResultStatus.PENDING, backendImport_1.TestResultStatus.RUNNING, backendImport_1.TestResultStatus.COMPLETED, backendImport_1.TestResultStatus.FAILED];
        // If status contains invalid text, that's probably the error message
        if (result.status && !validStatuses.includes(result.status)) {
            return result.status;
        }
        // Otherwise use the error field
        return result.error || null;
    }
};
exports.BotTestResults = BotTestResults;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.IBotTest !== "undefined" && backendImport_1.IBotTest) === "function" ? _a : Object)
], BotTestResults.prototype, "botTest", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], BotTestResults.prototype, "testResults", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], BotTestResults.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof Set !== "undefined" && Set) === "function" ? _b : Object)
], BotTestResults.prototype, "collapsedResults", void 0);
exports.BotTestResults = BotTestResults = __decorate([
    (0, client_1.RWSView)('bot-test-results', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], BotTestResults);
BotTestResults.defineComponent();
